import React from "react";
import { Elements } from "prismic-reactjs";

const propsWithUniqueKey = (props, key) => Object.assign(props || {}, { key });

const replaceUrl = (content, data) => {
  if (!content) {
    return "";
  }

  return content.replace("https://%baseUrl%", data);
};

const htmlSerializer = (type, element, content, children, key) => {
  if(type === Elements.hyperlink){
    const targetAttr = { target: "_blank" };
    const relAttr = { rel: "noopener" };
    const finalUrl = replaceUrl(element.data.url, process.env.HOMEPAGE_URL);
    
    const props = Object.assign(
      { href: finalUrl },
      targetAttr,
      relAttr
    );
    
    return React.createElement("a", propsWithUniqueKey(props, key), children);
  }

  return null;
};

export default htmlSerializer;
